export default __webpack_public_path__ + "static/assets/med_x_ampoule_2.7414b782.png";